module.exports = __webpack_public_path__ + "static/media/app-store-badge.d0558d91.svg";